/* @flow */

import React from 'react';

import Reset2FAComponent from 'app/users/reset2fa';
import WebsitePageComponent from 'components/websiteStructure/pages';

export default function Reset2FAPage() {

  return (
    <WebsitePageComponent id="twofactor.reset.title">
      <Reset2FAComponent />
    </WebsitePageComponent>
  );
}
